import { createTrainingMeetGroups } from './trainingMeetGroups.js';
import { buildTrainingAiResponse, delayTrainingAiResponse } from './trainingAiMock.js';

const TRAINING_GROUPING_DELAY_MS = 2000;
const TRAINING_AUTO_GROUP_SIZE = 6;

const jsonResponse = (payload, status = 200) => new Response(JSON.stringify(payload), {
    status,
    headers: { 'Content-Type': 'application/json' }
});

const textResponse = (payload, status = 200) => new Response(String(payload), {
    status,
    headers: { 'Content-Type': 'text/plain' }
});

const successResponse = (extra = {}) => jsonResponse({
    success: 'true',
    error: { errorCode: '', errorMessage: '' },
    ...extra
});

const getEndpointName = (input) => {
    const rawUrl = typeof input === 'string' ? input : input?.url;
    if (!rawUrl) return '';
    try {
        return new URL(rawUrl).pathname.split('/').filter(Boolean).pop() || '';
    } catch (error) {
        return String(rawUrl).split('/').filter(Boolean).pop() || '';
    }
};

const parseBodyParams = (init = {}) => {
    const body = init.body;
    if (!body) return new URLSearchParams();
    if (body instanceof URLSearchParams) return body;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
        const params = new URLSearchParams();
        body.forEach((value, key) => {
            params.append(key, value);
        });
        return params;
    }
    if (typeof body === 'string') return new URLSearchParams(body);
    return new URLSearchParams();
};

const clone = (value) => JSON.parse(JSON.stringify(value));

const managementData = [
    {
        countryID: '1',
        name: 'Taiwan',
        cities: [
            {
                cityID: '2',
                name: 'Taipei',
                districts: 'Training Campus',
                timezoneName: 'Asia/Taipei',
                price: 1200,
                seasonPrice: 5600,
                seasonReps: 5,
                taxRate: 5,
                discounted: '1',
                promoCode: 'TRAINING50',
                support: 'support-taipei',
                gateway: 'S',
                presale: '1',
                available: '1',
                mainLang: 'zh',
                language: 'zh'
            },
            {
                cityID: '3',
                name: 'Taichung',
                districts: 'Practice Area',
                timezoneName: 'Asia/Taipei',
                price: 1000,
                seasonPrice: 0,
                seasonReps: 0,
                taxRate: 5,
                discounted: '0',
                promoCode: '',
                support: 'support',
                gateway: 'S',
                presale: '0',
                available: '1',
                mainLang: 'zh',
                language: 'zh'
            }
        ]
    },
    {
        countryID: '2',
        name: 'Japan',
        cities: [
            {
                cityID: '8',
                name: 'Tokyo',
                districts: 'Training Lab',
                timezoneName: 'Asia/Tokyo',
                price: 3500,
                seasonPrice: 0,
                seasonReps: 0,
                taxRate: 10,
                discounted: '0',
                promoCode: 'YESBRUNCHJP',
                support: 'support-tokyo',
                gateway: 'S',
                presale: '0',
                available: '1',
                mainLang: 'ja',
                language: 'ja'
            }
        ]
    }
];

const trainingManagers = [
    {
        managerID: '1',
        name: 'Training Super Admin',
        email: 'training.superadmin@example.test',
        auth: '1',
        cityID: '2',
        cityName: 'Taipei - Training Campus',
        startDate: '2026-06-22'
    },
    {
        managerID: '31',
        name: 'Training City Manager',
        email: 'training.manager@example.test',
        auth: '2',
        cityID: '2',
        cityName: 'Taipei - Training Campus',
        startDate: '2026-06-22'
    },
    {
        managerID: '32',
        name: 'Training Japan Manager',
        email: 'training.japan@example.test',
        auth: '2',
        cityID: '8',
        cityName: 'Tokyo - Training Lab',
        startDate: '2026-06-22'
    }
];

const cityTags = [
    { tagID: '101', tagName: 'Training VIP', name: 'Training VIP' },
    { tagID: '102', tagName: 'Needs Follow-up', name: 'Needs Follow-up' },
    { tagID: '103', tagName: 'New Member', name: 'New Member' }
];

const resumes = [
    {
        resumeID: '9001',
        verificationPhotoID: '10',
        scheduleID: '7001',
        photoName: '51731_2026062503V58',
        needReverify: '0',
        name: 'Alex Training',
        UID: 'TR-0001',
        uid: 'TR-0001',
        email: 'alex.training@example.test',
        gender: '1',
        birthdate: '1992-04-12',
        actualAge: '34',
        introduction: 'Training profile for practicing review, grouping, notes, and rating flows.',
        rating: '4',
        managerRate: '4',
        mbti: 'ENFP',
        signUps: '5',
        blacklist: '0',
        tags: ['101', '103'],
        remarks: 'Mock remarks can be edited safely.',
        goodRatings: '7',
        goodRates: '7',
        vegan: '0',
        languages: 'English, Mandarin',
        nationality: 'Taiwan',
        nationalityID: '158',
        occupation: 'Product Manager',
        promoCode: 'TRAINING50',
        meetGroupID: '',
        groupedBefore: ['9003'],
        eatenBefore: ['Mock Cafe x 1'],
        partnerID: '',
        lastLocation: 'Training Bistro',
        liked: '2',
        talker: '1',
        listener: '1',
        striker: '0',
        superb: '1',
        available: '1',
        refundTime: '',
        riskAnalysis: '',
        traveledCountries: ['Japan', 'Singapore'],
        spokenLanguages: ['English', 'Mandarin'],
        meetGoals: ['Friends', 'Networking'],
        afterParties: ['Coffee']
    },
    {
        resumeID: '9002',
        verificationPhotoID: '10',
        scheduleID: '7002',
        photoName: '51651_2026062503md6',
        needReverify: '1',
        name: 'Bella Practice',
        UID: 'TR-0002',
        uid: 'TR-0002',
        email: 'bella.practice@example.test',
        gender: '0',
        birthdate: '1995-09-03',
        actualAge: '',
        introduction: 'Practice user with reverify status and editable tags.',
        rating: '3',
        managerRate: '3',
        mbti: 'INFJ',
        signUps: '2',
        blacklist: '0',
        tags: ['102'],
        remarks: '',
        goodRatings: '3',
        goodRates: '3',
        vegan: '1',
        languages: 'Mandarin, Japanese',
        nationality: 'Japan',
        nationalityID: '81',
        occupation: 'Designer',
        promoCode: '',
        meetGroupID: '',
        groupedBefore: [],
        eatenBefore: ['Training Bistro x 1'],
        partnerID: '',
        lastLocation: 'Mock Cafe',
        liked: '1',
        talker: '0',
        listener: '1',
        striker: '0',
        superb: '0',
        available: '1',
        refundTime: '',
        riskAnalysis: '',
        traveledCountries: ['Taiwan', 'Korea'],
        spokenLanguages: ['Mandarin', 'Japanese'],
        meetGoals: ['Dating'],
        afterParties: ['Dessert']
    },
    {
        resumeID: '9003',
        verificationPhotoID: '10',
        scheduleID: '7003',
        photoName: '51650_20260625039bg',
        needReverify: '0',
        name: 'Chris Demo',
        UID: 'TR-0003',
        uid: 'TR-0003',
        email: 'chris.demo@example.test',
        gender: '1',
        birthdate: '1989-12-22',
        actualAge: '36',
        introduction: 'Grouped training attendee with prior feedback examples.',
        rating: '5',
        managerRate: '5',
        mbti: 'ENTJ',
        signUps: '9',
        blacklist: '0',
        tags: ['101'],
        remarks: 'Good facilitator profile.',
        goodRatings: '11',
        goodRates: '11',
        vegan: '0',
        languages: 'English',
        nationality: 'Taiwan',
        nationalityID: '158',
        occupation: 'Engineer',
        promoCode: 'TRAININGVIP',
        meetGroupID: '',
        groupedBefore: ['9001'],
        eatenBefore: ['Training Bistro x 2', 'Mock Cafe x 1'],
        partnerID: '',
        lastLocation: 'Training Bistro',
        liked: '3',
        talker: '1',
        listener: '0',
        striker: '1',
        superb: '1',
        available: '1',
        refundTime: '',
        riskAnalysis: '',
        traveledCountries: ['USA', 'Thailand'],
        spokenLanguages: ['English'],
        meetGoals: ['Networking'],
        afterParties: []
    },
    {
        resumeID: '9004',
        verificationPhotoID: '10',
        scheduleID: '7004',
        photoName: '51648_2026062503am7',
        needReverify: '0',
        name: 'Diana Sandbox',
        UID: 'TR-0004',
        uid: 'TR-0004',
        email: 'diana.sandbox@example.test',
        gender: '0',
        birthdate: '1994-02-18',
        actualAge: '32',
        introduction: 'Training participant for manual grouping practice.',
        rating: '4',
        managerRate: '4',
        mbti: 'ISFJ',
        signUps: '4',
        blacklist: '0',
        tags: ['103'],
        remarks: '',
        goodRatings: '5',
        goodRates: '5',
        vegan: '0',
        languages: 'Mandarin, English',
        nationality: 'Taiwan',
        nationalityID: '158',
        occupation: 'Marketing Specialist',
        promoCode: '',
        meetGroupID: '',
        groupedBefore: ['9007'],
        eatenBefore: [],
        partnerID: '',
        lastLocation: 'Mock Cafe',
        liked: '1',
        talker: '0',
        listener: '1',
        striker: '0',
        superb: '0',
        available: '1',
        refundTime: '',
        riskAnalysis: '',
        traveledCountries: ['Japan'],
        spokenLanguages: ['Mandarin', 'English'],
        meetGoals: ['Friends'],
        afterParties: ['Tea']
    },
    {
        resumeID: '9005',
        verificationPhotoID: '10',
        scheduleID: '7005',
        photoName: '51731_2026062503V58',
        needReverify: '0',
        name: 'Ethan Mock',
        UID: 'TR-0005',
        uid: 'TR-0005',
        email: 'ethan.mock@example.test',
        gender: '1',
        birthdate: '1990-07-29',
        actualAge: '35',
        introduction: 'Mock attendee with networking interests.',
        rating: '4',
        managerRate: '4',
        mbti: 'INTP',
        signUps: '6',
        blacklist: '0',
        tags: ['101'],
        remarks: '',
        goodRatings: '8',
        goodRates: '8',
        vegan: '0',
        languages: 'English',
        nationality: 'United States',
        nationalityID: '840',
        occupation: 'Data Analyst',
        promoCode: 'THEMEDEMO',
        meetGroupID: '',
        groupedBefore: [],
        eatenBefore: ['Training Bistro x 1'],
        partnerID: '',
        lastLocation: 'Sandbox Dining',
        liked: '2',
        talker: '1',
        listener: '0',
        striker: '0',
        superb: '1',
        available: '1',
        refundTime: '',
        riskAnalysis: '',
        traveledCountries: ['Taiwan', 'Japan'],
        spokenLanguages: ['English'],
        meetGoals: ['Networking'],
        afterParties: []
    },
    {
        resumeID: '9006',
        verificationPhotoID: '10',
        scheduleID: '7006',
        photoName: '51651_2026062503md6',
        needReverify: '1',
        name: 'Fiona Drill',
        UID: 'TR-0006',
        uid: 'TR-0006',
        email: 'fiona.drill@example.test',
        gender: '0',
        birthdate: '1997-11-08',
        actualAge: '28',
        introduction: 'Training profile with a vegetarian preference.',
        rating: '3',
        managerRate: '3',
        mbti: 'ESFP',
        signUps: '1',
        blacklist: '0',
        tags: ['102', '103'],
        remarks: 'Practice reverify and dietary notes.',
        goodRatings: '2',
        goodRates: '2',
        vegan: '1',
        languages: 'Mandarin',
        nationality: 'Taiwan',
        nationalityID: '158',
        occupation: 'Teacher',
        promoCode: '',
        meetGroupID: '',
        groupedBefore: [],
        eatenBefore: [],
        partnerID: '',
        lastLocation: 'Training Bistro',
        liked: '0',
        talker: '1',
        listener: '1',
        striker: '0',
        superb: '0',
        available: '1',
        refundTime: '',
        riskAnalysis: '',
        traveledCountries: ['Thailand'],
        spokenLanguages: ['Mandarin'],
        meetGoals: ['Dating', 'Friends'],
        afterParties: ['Dessert']
    },
    {
        resumeID: '9007',
        verificationPhotoID: '10',
        scheduleID: '7007',
        photoName: '51650_20260625039bg',
        needReverify: '0',
        name: 'George Practice',
        UID: 'TR-0007',
        uid: 'TR-0007',
        email: 'george.practice@example.test',
        gender: '1',
        birthdate: '1988-05-16',
        actualAge: '38',
        introduction: 'Experienced training attendee for balanced tables.',
        rating: '5',
        managerRate: '5',
        mbti: 'ESTJ',
        signUps: '12',
        blacklist: '0',
        tags: ['101'],
        remarks: 'Reliable host in mock scenarios.',
        goodRatings: '14',
        goodRates: '14',
        vegan: '0',
        languages: 'Mandarin, English',
        nationality: 'Taiwan',
        nationalityID: '158',
        occupation: 'Operations Lead',
        promoCode: '',
        meetGroupID: '',
        groupedBefore: ['9004'],
        eatenBefore: ['Mock Cafe x 2'],
        partnerID: '',
        lastLocation: 'Mock Cafe',
        liked: '4',
        talker: '1',
        listener: '0',
        striker: '1',
        superb: '1',
        available: '1',
        refundTime: '',
        riskAnalysis: '',
        traveledCountries: ['Singapore', 'USA'],
        spokenLanguages: ['Mandarin', 'English'],
        meetGoals: ['Networking'],
        afterParties: ['Coffee']
    },
    {
        resumeID: '9008',
        verificationPhotoID: '10',
        scheduleID: '7008',
        photoName: '51648_2026062503am7',
        needReverify: '0',
        name: 'Hana Training',
        UID: 'TR-0008',
        uid: 'TR-0008',
        email: 'hana.training@example.test',
        gender: '0',
        birthdate: '1993-03-25',
        actualAge: '33',
        introduction: 'Mock attendee interested in culture and travel.',
        rating: '4',
        managerRate: '4',
        mbti: 'INFP',
        signUps: '3',
        blacklist: '0',
        tags: ['103'],
        remarks: '',
        goodRatings: '4',
        goodRates: '4',
        vegan: '0',
        languages: 'Japanese, English',
        nationality: 'Japan',
        nationalityID: '81',
        occupation: 'Translator',
        promoCode: '',
        meetGroupID: '',
        groupedBefore: [],
        eatenBefore: ['Training Bistro x 1'],
        partnerID: '',
        lastLocation: 'Training Bistro',
        liked: '2',
        talker: '0',
        listener: '1',
        striker: '0',
        superb: '0',
        available: '1',
        refundTime: '',
        riskAnalysis: '',
        traveledCountries: ['Taiwan', 'Korea'],
        spokenLanguages: ['Japanese', 'English'],
        meetGoals: ['Friends', 'Culture'],
        afterParties: []
    },
    {
        resumeID: '9009',
        verificationPhotoID: '10',
        scheduleID: '7009',
        photoName: '51731_2026062503V58',
        needReverify: '0',
        name: 'Ian Sample',
        UID: 'TR-0009',
        uid: 'TR-0009',
        email: 'ian.sample@example.test',
        gender: '1',
        birthdate: '1991-10-14',
        actualAge: '34',
        introduction: 'Sample attendee for restaurant assignment practice.',
        rating: '3',
        managerRate: '3',
        mbti: 'ISTP',
        signUps: '2',
        blacklist: '0',
        tags: [],
        remarks: '',
        goodRatings: '2',
        goodRates: '2',
        vegan: '0',
        languages: 'English, Mandarin',
        nationality: 'Taiwan',
        nationalityID: '158',
        occupation: 'Photographer',
        promoCode: 'TRAINING50',
        meetGroupID: '',
        groupedBefore: [],
        eatenBefore: [],
        partnerID: '',
        lastLocation: 'Sandbox Dining',
        liked: '1',
        talker: '0',
        listener: '1',
        striker: '1',
        superb: '0',
        available: '1',
        refundTime: '',
        riskAnalysis: '',
        traveledCountries: ['Japan'],
        spokenLanguages: ['English', 'Mandarin'],
        meetGoals: ['Dating'],
        afterParties: ['Bar']
    },
    {
        resumeID: '9010',
        verificationPhotoID: '10',
        scheduleID: '7010',
        photoName: '51651_2026062503md6',
        needReverify: '0',
        name: 'Judy Demo',
        UID: 'TR-0010',
        uid: 'TR-0010',
        email: 'judy.demo@example.test',
        gender: '0',
        birthdate: '1996-01-30',
        actualAge: '30',
        introduction: 'Demo participant for practicing final group balancing.',
        rating: '4',
        managerRate: '4',
        mbti: 'ENFJ',
        signUps: '7',
        blacklist: '0',
        tags: ['101', '103'],
        remarks: '',
        goodRatings: '9',
        goodRates: '9',
        vegan: '0',
        languages: 'Mandarin, Korean',
        nationality: 'Taiwan',
        nationalityID: '158',
        occupation: 'Project Coordinator',
        promoCode: '',
        meetGroupID: '',
        groupedBefore: [],
        eatenBefore: ['Mock Cafe x 1'],
        partnerID: '',
        lastLocation: 'Mock Cafe',
        liked: '3',
        talker: '1',
        listener: '1',
        striker: '0',
        superb: '1',
        available: '1',
        refundTime: '',
        riskAnalysis: '',
        traveledCountries: ['Korea', 'Japan'],
        spokenLanguages: ['Mandarin', 'Korean'],
        meetGoals: ['Friends', 'Networking'],
        afterParties: ['Coffee']
    }
];

const restaurants = [
    {
        locationID: '301',
        cityID: '2',
        name: 'Training Bistro',
        address: '1 Mock Road, Taipei',
        link: 'https://maps.example.test/training-bistro',
        available: '1',
        bookedTimes: ['2026-06-25 19:30:00']
    },
    {
        locationID: '302',
        cityID: '2',
        name: 'Mock Cafe',
        address: '2 Practice Lane, Taipei',
        link: 'https://maps.example.test/mock-cafe',
        available: '1',
        bookedTimes: []
    },
    {
        locationID: '303',
        cityID: '3',
        name: 'Sandbox Dining',
        address: '3 Training Street, Taichung',
        link: 'https://maps.example.test/sandbox-dining',
        available: '0',
        bookedTimes: []
    }
];

const meetTimes = [
    {
        cityMeetTimeID: '1201',
        cityID: '2',
        deadline: '2026-06-25 12:00:00',
        meetTime: '2026-06-25 19:30:00'
    },
    {
        cityMeetTimeID: '1202',
        cityID: '2',
        deadline: '2026-06-26 12:00:00',
        meetTime: '2026-06-26 19:30:00'
    },
    {
        cityMeetTimeID: '1203',
        cityID: '3',
        deadline: '2026-06-27 09:00:00',
        meetTime: '2026-06-27 12:00:00'
    }
];

meetTimes.forEach((row, index) => {
    row.meetTimeID = `training-meet-${row.cityMeetTimeID}`;
    row.type = ['Dinner', 'Theme Table', 'Brunch'][index];
});
meetTimes.push({ ...meetTimes[0], cityMeetTimeID: '1199', meetTimeID: 'training-meet-1199', type: 'Theme Table' });
const trainingSaturday = new Date();
const trainingWeekday = trainingSaturday.getDay();
trainingSaturday.setDate(trainingSaturday.getDate() + (trainingWeekday >= 1 && trainingWeekday <= 5 ? 6 - trainingWeekday : 0));
const trainingDate = [trainingSaturday.getFullYear(), String(trainingSaturday.getMonth() + 1).padStart(2, '0'), String(trainingSaturday.getDate()).padStart(2, '0')].join('-');
meetTimes.push(...['Brunch', 'Theme Table'].map((type, index) => ({
    cityMeetTimeID: `training-current-${index}`, meetTimeID: `training-current-${index}`,
    cityID: '2', meetTime: `${trainingDate} 11:00:00`, deadline: '', type
})));

const meetTimeRules = [
    {
        meetTimeRuleID: '2001',
        cityID: '2',
        weekly: '1',
        day: '5',
        startTime: '19:30',
        endTime: '21:30',
        deadline: '1440',
        available: '1'
    },
    {
        meetTimeRuleID: '2002',
        cityID: '2',
        weekly: '2',
        day: '6',
        startTime: '11:00',
        endTime: '13:00',
        deadline: '2820',
        available: '0'
    }
];

const promoCodes = [
    {
        promoCodeID: '801',
        cityID: '2',
        countryID: '1',
        promoCode: 'TRAINING50',
        code: 'TRAINING50',
        location: 'Taipei',
        status: 'Active',
        timeSlot: '',
        type: 'amount',
        value: '500',
        currency: 'TWD',
        expiration: '2026-12-31 23:59:59',
        firstTime: '1',
        usedCount: '3',
        usePerUser: '1',
        totalLimit: '100',
        details: 'Training discount code',
        isPublic: '0'
    },
    {
        promoCodeID: '802',
        cityID: '2',
        countryID: '1',
        promoCode: 'THEMEDEMO',
        code: 'THEMEDEMO',
        location: 'Taipei',
        status: 'Active',
        timeSlot: '2026-06-25 19:30:00',
        type: 'percent',
        value: '20',
        currency: 'TWD',
        expiration: '2026-12-31 23:59:59',
        firstTime: '0',
        usedCount: '1',
        usePerUser: '1',
        totalLimit: '10',
        details: 'Theme table training code',
        isPublic: '1'
    }
];

const notifications = [
    {
        notificationID: '601',
        cityID: '2',
        lang: 'zh',
        content: 'Training Mode notification. Safe to edit.',
        sendTime: '2026-06-25 10:00:00',
        details: 'Training detail content',
        promoCodeID: '801'
    }
];

const edmTypes = [
    { typeID: '1', type: 'event_reminder', name: 'Training Event Reminder' },
    { typeID: '2', type: 'feedback_followup', name: 'Training Feedback Follow-up' }
];

const edms = [
    {
        edmID: '701',
        typeID: '1',
        versionName: 'Training Reminder v1',
        lang: 'zh',
        subject: 'Training Mode EDM',
        inUse: '1',
        cityIDs: ['2']
    }
];

const feedbacks = [
    {
        groupID: '601',
        timeSlot: '2026-06-25 19:30:00',
        locationID: '301',
        location: 'Training Bistro',
        feedbacks: [
            {
                rater: 'Alex Training',
                raterUID: 'TR-0001',
                raterPhoto: '51731_2026062503V58',
                location: 'Training Bistro',
                locationID: '301',
                refer: '1',
                referReason: 'Good flow and easy conversation. Training note: this is safe mock data.',
                locationLiked: '1',
                locationTags: ['Good service', 'Easy seating'],
                locationRemarks: 'Staff handled the practice group smoothly.',
                attendees: [
                    {
                        name: 'Bella Practice',
                        attendeeUID: 'TR-0002',
                        attendeeLiked: '1',
                        tags: ['Friendly', 'Clear communicator'],
                        attendance: '',
                        remarks: 'Easy to talk to and helped keep the table moving.'
                    },
                    {
                        name: 'Chris Demo',
                        attendeeUID: 'TR-0003',
                        attendeeLiked: '7',
                        tags: ['Reserved'],
                        attendance: '',
                        remarks: 'Neutral mock evaluation for table review practice.'
                    }
                ]
            },
            {
                rater: 'Bella Practice',
                raterUID: 'TR-0002',
                raterPhoto: '51651_2026062503md6',
                location: 'Training Bistro',
                locationID: '301',
                refer: '1',
                referReason: 'Would recommend this event to friends.',
                locationLiked: '1',
                locationTags: ['Food quality'],
                locationRemarks: 'Comfortable table spacing.',
                attendees: [
                    {
                        name: 'Alex Training',
                        attendeeUID: 'TR-0001',
                        attendeeLiked: '1',
                        tags: ['Warm host'],
                        attendance: '',
                        remarks: 'Asked thoughtful questions.'
                    },
                    {
                        name: 'Chris Demo',
                        attendeeUID: 'TR-0003',
                        attendeeLiked: '0',
                        tags: ['Low engagement'],
                        attendance: '1',
                        remarks: 'Arrived late in this mock case and joined slowly.'
                    }
                ]
            }
        ]
    },
    {
        groupID: '602',
        timeSlot: '2026-06-26 19:30:00',
        locationID: '302',
        location: 'Mock Cafe',
        feedbacks: [
            {
                rater: 'Diana Sandbox',
                raterUID: 'TR-0004',
                raterPhoto: '51648_2026062503am7',
                location: 'Mock Cafe',
                locationID: '302',
                refer: '0',
                referReason: 'The pacing felt uneven; useful mock row for the not-recommend filter.',
                locationLiked: '0',
                locationTags: ['Too noisy', 'Slow service'],
                locationRemarks: 'Noise level made conversation practice harder.',
                attendees: [
                    {
                        name: 'Ethan Mock',
                        attendeeUID: 'TR-0005',
                        attendeeLiked: '0',
                        tags: ['Dominated conversation'],
                        attendance: '',
                        remarks: 'Training negative review example.'
                    },
                    {
                        name: 'Fiona Drill',
                        attendeeUID: 'TR-0006',
                        attendeeLiked: '1',
                        tags: ['Good listener'],
                        attendance: '',
                        remarks: 'Helped balance the conversation.'
                    }
                ]
            },
            {
                rater: 'Ethan Mock',
                raterUID: 'TR-0005',
                raterPhoto: '51731_2026062503V58',
                location: 'Mock Cafe',
                locationID: '302',
                refer: '1',
                referReason: 'Would try another event with clearer group guidance.',
                locationLiked: '0',
                locationTags: ['Crowded'],
                locationRemarks: 'Mock restaurant improvement note.',
                attendees: [
                    {
                        name: 'Diana Sandbox',
                        attendeeUID: 'TR-0004',
                        attendeeLiked: '7',
                        tags: ['Neutral'],
                        attendance: '',
                        remarks: 'No strong impression in this practice row.'
                    },
                    {
                        name: 'Fiona Drill',
                        attendeeUID: 'TR-0006',
                        attendeeLiked: '0',
                        tags: ['Quiet'],
                        attendance: '0',
                        remarks: 'No-show mock case for filter testing.'
                    }
                ]
            }
        ]
    },
    {
        groupID: '603',
        timeSlot: '2026-06-27 12:00:00',
        locationID: '303',
        location: 'Sandbox Dining',
        feedbacks: [
            {
                rater: 'George Practice',
                raterUID: 'TR-0007',
                raterPhoto: '51650_20260625039bg',
                location: 'Sandbox Dining',
                locationID: '303',
                refer: '1',
                referReason: 'Good lunch event with balanced introductions.',
                locationLiked: '1',
                locationTags: ['Bright space'],
                locationRemarks: 'Good daytime mock venue.',
                attendees: [
                    {
                        name: 'Hana Training',
                        attendeeUID: 'TR-0008',
                        attendeeLiked: '1',
                        tags: ['Curious', 'Travel topics'],
                        attendance: '',
                        remarks: 'Shared travel stories and kept discussion active.'
                    },
                    {
                        name: 'Ian Sample',
                        attendeeUID: 'TR-0009',
                        attendeeLiked: '1',
                        tags: ['Considerate'],
                        attendance: '',
                        remarks: 'Polite and easy to include.'
                    }
                ]
            },
            {
                rater: 'Judy Demo',
                raterUID: 'TR-0010',
                raterPhoto: '51651_2026062503md6',
                location: 'Sandbox Dining',
                locationID: '303',
                refer: '0',
                referReason: '',
                locationLiked: '1',
                locationTags: [],
                locationRemarks: '',
                attendees: [
                    {
                        name: 'George Practice',
                        attendeeUID: 'TR-0007',
                        attendeeLiked: '1',
                        tags: ['Reliable host'],
                        attendance: '',
                        remarks: 'Helped new attendees feel comfortable.'
                    },
                    {
                        name: 'Ian Sample',
                        attendeeUID: 'TR-0009',
                        attendeeLiked: '0',
                        tags: ['Needs follow-up'],
                        attendance: '',
                        remarks: 'Mock case for manager follow-up practice.'
                    }
                ]
            }
        ]
    }
];

const feedbackStats = [
    {
        weekOf: '2026-06-01',
        attendeeFeedbackRate: 720,
        willRefer: 680,
        wontRefer: 160,
        attendeeLikedRate: 740,
        attendeeDislikedRate: 140,
        noShowRate: 80,
        lateRate: 100,
        locationLikedRate: 720,
        locationDislikedRate: 180,
        locationFeedbackRate: 700
    },
    {
        weekOf: '2026-06-08',
        attendeeFeedbackRate: 760,
        willRefer: 710,
        wontRefer: 140,
        attendeeLikedRate: 760,
        attendeeDislikedRate: 130,
        noShowRate: 70,
        lateRate: 90,
        locationLikedRate: 730,
        locationDislikedRate: 170,
        locationFeedbackRate: 720
    },
    {
        weekOf: '2026-06-15',
        attendeeFeedbackRate: 790,
        willRefer: 730,
        wontRefer: 120,
        attendeeLikedRate: 780,
        attendeeDislikedRate: 120,
        noShowRate: 60,
        lateRate: 80,
        locationLikedRate: 750,
        locationDislikedRate: 150,
        locationFeedbackRate: 740
    },
    {
        weekOf: '2026-06-22',
        attendeeFeedbackRate: 820,
        willRefer: 760,
        wontRefer: 110,
        attendeeLikedRate: 810,
        attendeeDislikedRate: 100,
        noShowRate: 50,
        lateRate: 70,
        locationLikedRate: 780,
        locationDislikedRate: 130,
        locationFeedbackRate: 770
    }
];

const paymentRows = [
    {
        resumeID: '9001',
        uid: 'TR-0001',
        name: 'Alex Training',
        email: 'alex.training@example.test',
        amount: 150000,
        price: 150000,
        currency: 'TWD',
        status: 'captured',
        payTime: '2026-06-20 12:00:00',
        captureTime: '2026-06-20 12:05:00',
        promoCode: 'TRAINING50',
        totalLimit: '5',
        usedTimes: '1',
        expirationTime: '2026-12-31 23:59:59'
    },
    {
        resumeID: '9002',
        uid: 'TR-0002',
        name: 'Bella Practice',
        email: 'bella.practice@example.test',
        amount: 120000,
        price: 120000,
        currency: 'TWD',
        status: 'authorized',
        payTime: '2026-06-21 12:00:00',
        captureTime: '',
        promoCode: 'THEMEDEMO',
        totalLimit: '3',
        usedTimes: '1',
        expirationTime: '2026-12-31 23:59:59'
    }
];

const signUpStatsRows = [
    {
        country: 'Hong Kong',
        city: 'Hong Kong',
        districts: 'Jordan / Tsim Sha Tsui',
        signUps: '3'
    },
    {
        country: 'Hong Kong',
        city: 'Hong Kong',
        districts: 'Wan Chai / Causeway Bay',
        signUps: '2'
    },
    {
        country: 'Taiwan',
        city: 'Hsinchu',
        districts: 'Downtown',
        signUps: '4'
    },
    {
        country: 'Taiwan',
        city: 'Kaohsiung',
        districts: 'Downtown',
        signUps: '3'
    },
    {
        country: 'Taiwan',
        city: 'Taichung',
        districts: 'Downtown',
        signUps: '4'
    },
    {
        country: 'Taiwan',
        city: 'Tainan',
        districts: 'Downtown',
        signUps: '2'
    }
];

const meetTypes = [
    {
        cityID: '2',
        meetTypeID: '2',
        type: 'Meal',
        markUp: '0',
        category: '1',
        locales: [],
        available: '1'
    },
    {
        cityID: '2',
        meetTypeID: '3',
        type: 'Bookwarm',
        markUp: '15000',
        category: '2',
        locales: [
            {
                meetTypeLocaleID: '3',
                title: '書蟲桌',
                details: '帶著最近喜歡的一本書，和同桌分享閱讀靈感。',
                locale: 'zh'
            },
            {
                meetTypeLocaleID: '4',
                title: 'Bookwarm',
                details: 'Share a recent favorite book and meet other curious readers.',
                locale: 'en'
            }
        ],
        available: '1'
    },
    {
        cityID: '2',
        meetTypeID: '4',
        type: 'NewToTPE',
        markUp: '5000',
        category: '2',
        locales: [
            {
                meetTypeLocaleID: '5',
                title: '我不是台北人',
                details: '從外縣市或國外來到台北生活，一起交換城市新鮮人的日常。',
                locale: 'zh'
            }
        ],
        available: '0'
    },
    {
        cityID: '3',
        meetTypeID: '5',
        type: 'TaichungCreators',
        markUp: '0',
        category: '1',
        locales: [],
        available: '1'
    },
    {
        cityID: '8',
        meetTypeID: '6',
        type: 'TokyoNewcomers',
        markUp: '1000',
        category: '1',
        locales: [],
        available: '1'
    }
];

const state = {
    nextGroupID: 503,
    nextPromoCodeID: 803,
    nextNotificationID: 602,
    nextEdmID: 702,
    nextManagerID: 40,
    nextCityMeetTimeID: 1204,
    nextMeetTimeRuleID: 2003,
    nextMeetTypeID: 7,
    nextMeetTypeLocaleID: 6,
    cityMeetTimes: clone(meetTimes).map(row => ({ ...row, signUps: '0', available: '1' })),
    cityMeetTimeRules: clone(meetTimeRules),
    meetTypes: clone(meetTypes),
    restaurantBookings: new Map(),
    groupedAttendees: null,
    ungroupedScheduleIDs: null,
    managers: clone(trainingManagers)
};

const meetGroups = createTrainingMeetGroups({ getMeets: () => state.cityMeetTimes, getAttendees: () => resumes, groupSize: TRAINING_AUTO_GROUP_SIZE });
const trainingMeetResponse = action => {
    try { return jsonResponse(clone(action())); }
    catch (error) { return jsonResponse({ success: 'false', error: { errorCode: 'TRAINING_MEET_ERROR', errorMessage: error.message } }, 400); }
};

const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const resetTrainingGroupStateForTest = () => {
    meetGroups.reset();
    state.restaurantBookings.clear();
    state.nextGroupID = 503;
    state.nextCityMeetTimeID = 1204;
    state.nextMeetTimeRuleID = 2003;
    state.nextMeetTypeID = 7;
    state.nextMeetTypeLocaleID = 6;
    state.cityMeetTimes = clone(meetTimes).map(row => ({ ...row, signUps: '0', available: '1' }));
    state.cityMeetTimeRules = clone(meetTimeRules);
    state.meetTypes = clone(meetTypes);
    state.groupedAttendees = null;
    state.ungroupedScheduleIDs = null;
};

const findTrainingCity = (cityID) => {
    for (const country of managementData) {
        const city = country.cities.find(item => String(item.cityID) === String(cityID));
        if (city) {
            return { ...city, countryID: country.countryID, countryName: country.name };
        }
    }
    return null;
};

const filterTrainingCityMeetTimes = (params) => {
    const cityID = params.get('cityID') || '';
    const startDate = params.get('startDate') || '';
    const endDate = params.get('endDate') || '';

    return state.cityMeetTimes.filter(row => {
        if (cityID && String(row.cityID) !== String(cityID)) {
            return false;
        }

        const meetDate = String(row.meetTime || '').slice(0, 10);
        if (startDate && meetDate < startDate) {
            return false;
        }

        if (endDate && meetDate > endDate) {
            return false;
        }

        return true;
    });
};

const getTrainingCityMovableMeetTimes = (params) => {
    const city = findTrainingCity(params.get('cityID') || '');
    return filterTrainingCityMeetTimes(params).map(row => ({
        meetTimeID: String(row.meetTimeID || ''),
        districts: city?.districts || '',
        meetTime: row.meetTime,
        meetType: row.type || ''
    }));
};

const addTrainingCityMeetTime = (params) => {
    const cityID = params.get('cityID') || '';
    const meetTime = params.get('meetTime') || '';
    const deadline = params.get('deadline') || '';
    const meetTypeID = params.get('meetTypeID') || '';
    const spots = params.get('spots') || '1000';
    if (!meetTypeID) {
        return jsonResponse({
            success: 'false',
            error: { errorCode: '400', errorMessage: 'meetTypeID is required.' }
        });
    }
    const row = {
        cityMeetTimeID: String(state.nextCityMeetTimeID++),
        meetTimeID: `training-added-${state.nextCityMeetTimeID - 1}`,
        cityID,
        deadline,
        meetTime,
        meetTypeID,
        spots,
        signUps: '0',
        available: '1'
    };

    state.cityMeetTimes.push(row);
    return jsonResponse({ meetTimeID: row.meetTimeID, type: '', meetTime, deadline, spots, signUps: row.signUps, available: row.available });
};

const removeTrainingCityMeetTime = (params) => {
    const cityMeetTimeID = params.get('cityMeetTimeID') || '';
    const row = state.cityMeetTimes.find(row => String(row.cityMeetTimeID) === String(cityMeetTimeID));
    if (!row) return jsonResponse({ success: 'false' });
    if (Number(row.signUps) > 0) return jsonResponse({ success: 'false', errorCode: '10060' });
    row.available = '0';
    return successResponse({ cityMeetTimeID });
};

const updateTrainingCityMeetTime = (params) => {
    const cityMeetTimeID = params.get('cityMeetTimeID') || '';
    const row = state.cityMeetTimes.find(item => String(item.cityMeetTimeID) === String(cityMeetTimeID));
    if (!row) {
        return jsonResponse({
            success: 'false',
            error: {
                errorCode: '404',
                errorMessage: 'Training meet time was not found.'
            }
        });
    }

    row.deadline = params.get('deadline') ?? row.deadline;
    row.spots = params.get('spots') ?? row.spots;
    return successResponse({ cityMeetTimeID, deadline: row.deadline, spots: row.spots });
};

const filterTrainingCityMeetTimeRules = (params) => {
    const cityID = params.get('cityID') || '';
    return state.cityMeetTimeRules
        .filter(row => !cityID || String(row.cityID) === String(cityID))
        .map(({ cityID: _cityID, ...row }) => clone(row));
};

const addTrainingCityMeetTimeRule = (params) => {
    const row = {
        meetTimeRuleID: String(state.nextMeetTimeRuleID++),
        cityID: params.get('cityID') || '',
        weekly: params.get('weekly') || '',
        day: params.get('day') || '',
        startTime: params.get('startTime') || '',
        endTime: params.get('endTime') || '',
        deadline: params.get('deadline') || '',
        available: '1'
    };
    state.cityMeetTimeRules.push(row);
    const { cityID: _cityID, ...responseRow } = row;
    return jsonResponse(clone(responseRow));
};

const updateTrainingCityMeetTimeRule = (params) => {
    const meetTimeRuleID = params.get('cityMeetTimeRuleID') || '';
    const row = state.cityMeetTimeRules.find(item => String(item.meetTimeRuleID) === String(meetTimeRuleID));
    if (!row) {
        return jsonResponse({
            success: 'false',
            error: {
                errorCode: '404',
                errorMessage: 'Training meet time rule was not found.'
            }
        });
    }

    ['weekly', 'day', 'startTime', 'endTime', 'deadline', 'available'].forEach(field => {
        row[field] = params.get(field) ?? row[field];
    });
    return successResponse();
};

const filterTrainingCityMeetTypes = (params) => {
    const cityID = params.get('cityID') || '';
    return state.meetTypes
        .filter(row => !cityID || String(row.cityID) === String(cityID))
        .map(({ cityID: _cityID, ...row }) => clone(row));
};

const filterTrainingAvailableMeetTypes = (params) => filterTrainingCityMeetTypes(params)
    .filter(row => String(row.available) === '1')
    .map(({ locales: _locales, available: _available, ...row }) => row);

const createTrainingMeetType = (params) => {
    state.meetTypes.push({
        cityID: params.get('cityID') || '',
        meetTypeID: String(state.nextMeetTypeID++),
        type: params.get('type') || '',
        markUp: params.get('markUp') || '0',
        category: params.get('category') || '1',
        locales: [],
        available: '1'
    });
    return successResponse();
};

const updateTrainingMeetType = (params) => {
    const meetTypeID = params.get('meetTypeID') || '';
    const row = state.meetTypes.find(item => String(item.meetTypeID) === String(meetTypeID));
    if (!row) {
        return jsonResponse({
            success: 'false',
            error: { errorCode: '404', errorMessage: 'Training meet type was not found.' }
        });
    }
    ['type', 'markUp', 'category', 'available', 'discountable'].forEach(field => {
        row[field] = params.get(field) ?? row[field];
    });
    return successResponse();
};

const addTrainingMeetTypeLocale = (params) => {
    const meetTypeID = params.get('meetTypeID') || '';
    const row = state.meetTypes.find(item => String(item.meetTypeID) === String(meetTypeID));
    if (!row) {
        return jsonResponse({
            success: 'false',
            error: { errorCode: '404', errorMessage: 'Training meet type was not found.' }
        });
    }
    row.locales.push({
        meetTypeLocaleID: String(state.nextMeetTypeLocaleID++),
        title: params.get('title') || '',
        details: params.get('details') || '',
        locale: params.get('locale') || ''
    });
    return successResponse();
};

const updateTrainingMeetTypeLocale = (params) => {
    const meetTypeLocaleID = params.get('meetTypeLocaleID') || '';
    const localeRecord = state.meetTypes
        .flatMap(item => item.locales)
        .find(item => String(item.meetTypeLocaleID) === String(meetTypeLocaleID));
    if (!localeRecord) {
        return jsonResponse({
            success: 'false',
            error: { errorCode: '404', errorMessage: 'Training meet type locale was not found.' }
        });
    }
    ['title', 'details', 'locale'].forEach(field => {
        localeRecord[field] = params.get(field) ?? localeRecord[field];
    });
    return successResponse();
};

const getTrainingCityDisplayName = (cityID) => {
    const city = findTrainingCity(cityID);
    if (!city) return '';
    return city.districts ? `${city.name} - ${city.districts}` : city.name;
};

const createTrainingManager = (params) => {
    const managerID = String(state.nextManagerID++);
    const manager = {
        managerID,
        name: params.get('name') || 'Training Manager',
        email: params.get('email') || `training.manager.${managerID}@example.test`,
        auth: params.get('auth') || '2',
        active: '1',
        cityID: '',
        cityName: '',
        startDate: ''
    };
    state.managers.push(manager);
    return successResponse({ managerID, manager });
};

const getTrainingManagers = () => {
    const grouped = new Map();

    state.managers.forEach(manager => {
        const managerID = String(manager.managerID || '');
        if (!managerID) return;

        if (!grouped.has(managerID)) {
            grouped.set(managerID, {
                managerID,
                name: manager.name || '',
                email: manager.email || '',
                authorization: String(manager.authorization ?? manager.auth ?? ''),
                active: String(manager.active ?? '1'),
                cities: []
            });
        }

        const normalized = grouped.get(managerID);
        if (manager.cityName && !normalized.cities.includes(manager.cityName)) {
            normalized.cities.push(manager.cityName);
        }
    });

    return Array.from(grouped.values());
};

const assignTrainingManagerToCity = (params) => {
    const managerID = params.get('assigningManagerID') || '';
    const cityID = params.get('cityID') || '';
    const startDate = params.get('startDate') || '';
    let manager = state.managers.find(item => String(item.managerID) === String(managerID));

    if (!manager) {
        manager = {
            managerID,
            name: `Training Manager ${managerID}`,
            email: '',
            auth: '2',
            active: '1',
            cityID: '',
            cityName: '',
            startDate: ''
        };
        state.managers.push(manager);
    }

    manager.cityID = cityID;
    manager.cityName = getTrainingCityDisplayName(cityID);
    manager.startDate = startDate;
    return successResponse({ manager });
};

const revokeTrainingManager = (params) => {
    const revokeManagerID = params.get('revokeManagerID') || '';
    const manager = state.managers.find(item => String(item.managerID) === String(revokeManagerID));
    if (manager) {
        manager.active = '0';
    }
    return successResponse();
};

const resetTrainingManagerPassword = (params) => {
    const resetManagerID = params.get('resetManagerID') || '';
    return successResponse({
        managerID: resetManagerID,
        password: 'training123'
    });
};

const filterPromoCodes = (params) => {
    const countryID = params.get('countryID');
    const cityID = params.get('cityID');
    const isPublic = params.get('isPublic');
    return promoCodes.filter(item => {
        if (countryID && String(item.countryID) !== String(countryID)) return false;
        if (cityID && String(item.cityID) !== String(cityID)) return false;
        if (isPublic !== null && isPublic !== '' && String(item.isPublic) !== String(isPublic)) return false;
        return true;
    });
};

const feedbackMatchesUidFilter = (feedback, uid, uidMode) => {
    if (!uid) return true;
    const normalizedUid = String(uid).trim().toLowerCase();
    const raterMatches = String(feedback.raterUID || '').toLowerCase().includes(normalizedUid);
    const attendeeMatches = (feedback.attendees || []).some(attendee => (
        String(attendee.attendeeUID || '').toLowerCase().includes(normalizedUid)
    ));

    if (uidMode === '1') return raterMatches;
    if (uidMode === '2') return attendeeMatches;
    return raterMatches || attendeeMatches;
};

const feedbackMatchesDislikeFilter = (feedback, dislike) => {
    if (!dislike) return true;
    if (dislike === '1') {
        return (feedback.attendees || []).some(attendee => String(attendee.attendeeLiked) === '0')
            || String(feedback.locationLiked) === '0';
    }
    if (dislike === '5') {
        return (feedback.attendees || []).some(attendee => String(attendee.attendance) === '0');
    }
    if (dislike === '10') {
        return String(feedback.refer) === '0';
    }
    return true;
};

const filterFeedbackGroups = (params = new URLSearchParams()) => {
    const groupID = params.get('groupID');
    const uid = params.get('uid');
    const uidMode = params.get('uidMode');
    const dislike = params.get('dislike');
    const locationID = params.get('locationID');

    return feedbacks
        .filter(group => !groupID || String(group.groupID) === String(groupID))
        .filter(group => !locationID || String(group.locationID) === String(locationID))
        .map(group => ({
            ...group,
            feedbacks: group.feedbacks.filter(feedback => (
                feedbackMatchesUidFilter(feedback, uid, uidMode)
                && feedbackMatchesDislikeFilter(feedback, dislike)
            ))
        }))
        .filter(group => group.feedbacks.length > 0);
};

const buildFeedbackStats = (params = new URLSearchParams()) => {
    const locationID = params.get('locationID');
    const groupID = params.get('groupID');
    const uid = params.get('uid');

    if (!locationID && !groupID && !uid) {
        return feedbackStats;
    }

    return feedbackStats.map((item, index) => {
        const adjustment = locationID ? -40 : groupID ? -25 : -15;
        const positiveAdjustment = locationID === '302' ? -80 : adjustment;
        const negativeAdjustment = locationID === '302' ? 60 : Math.abs(adjustment);
        return {
            ...item,
            attendeeFeedbackRate: Math.max(0, item.attendeeFeedbackRate + adjustment),
            willRefer: Math.max(0, item.willRefer + positiveAdjustment),
            wontRefer: Math.max(0, item.wontRefer + negativeAdjustment),
            attendeeLikedRate: Math.max(0, item.attendeeLikedRate + positiveAdjustment + index * 5),
            attendeeDislikedRate: Math.max(0, item.attendeeDislikedRate + negativeAdjustment),
            noShowRate: Math.max(0, item.noShowRate + (locationID === '302' ? 30 : 5)),
            lateRate: Math.max(0, item.lateRate + (locationID === '301' ? 10 : 0)),
            locationLikedRate: Math.max(0, item.locationLikedRate + positiveAdjustment),
            locationDislikedRate: Math.max(0, item.locationDislikedRate + negativeAdjustment),
            locationFeedbackRate: Math.max(0, item.locationFeedbackRate + adjustment)
        };
    });
};

const shuffled = (items = []) => (
    [...items].sort(() => Math.random() - 0.5)
);

const ensureTrainingGroupState = () => {
    if (!Array.isArray(state.groupedAttendees)) {
        state.groupedAttendees = [];
    }

    if (!Array.isArray(state.ungroupedScheduleIDs)) {
        state.ungroupedScheduleIDs = resumes.map(attendee => String(attendee.scheduleID));
    }
};

const findTrainingRestaurant = (locationID) => (
    restaurants.find(location => String(location.locationID) === String(locationID)) || null
);

const cloneTrainingAttendeeForGroup = (attendee, meetGroupID = '') => ({
    ...attendee,
    meetGroupID: String(meetGroupID || ''),
    riskAnalysis: attendee.riskAnalysis || (meetGroupID ? JSON.stringify({
        final_assessment: {
            '風險值': 10,
            '風險總評': 'Training Mode mock: AI 風險評估已模擬通過。',
            severity: 'none',
            recommended_action: 'allow'
        }
    }) : '')
});

const findTrainingGroup = (groupID) => {
    ensureTrainingGroupState();
    return meetGroups.findGroup(groupID) || state.groupedAttendees.find(group => String(group.meetGroupID) === String(groupID)) || null;
};

const createTrainingGroup = (params = new URLSearchParams()) => {
    ensureTrainingGroupState();
    const meetGroupID = String(state.nextGroupID++);
    const timeSlot = params.get('timeSlot') || meetTimes[0].meetTime;
    state.groupedAttendees.push({
        meetGroupID,
        bookedTime: timeSlot,
        locationID: '',
        locationName: '',
        reservationName: '',
        remarks: '',
        reasons: [],
        reasonAnalysis: '',
        locked: '0',
        modelID: '',
        attendees: []
    });

    return { meetGroupID, success: 'true' };
};

const updateTrainingGroupInfo = (params = new URLSearchParams()) => {
    const groupID = params.get('groupID');
    const group = findTrainingGroup(groupID);
    if (!group) {
        return successResponse();
    }

    if (params.has('locationID')) {
        const locationID = params.get('locationID') || '';
        const location = findTrainingRestaurant(locationID);
        group.locationID = locationID;
        group.locationName = location?.name || '';
    }

    if (params.has('reservation')) {
        group.reservationName = params.get('reservation') || '';
    }

    if (params.has('remarks')) {
        group.remarks = params.get('remarks') || '';
    }

    if (params.has('locked')) {
        group.locked = String(params.get('locked') || '0');
    }

    if (params.has('modelID')) {
        group.modelID = params.get('modelID') || '';
    }

    return successResponse();
};

const updateTrainingGroupReason = (params = new URLSearchParams()) => {
    const group = findTrainingGroup(params.get('groupID'));
    if (!group) {
        return successResponse();
    }

    const reason = params.get('reason') || '';
    const localizedReasons = [];
    params.forEach((value, key) => {
        if (!['groupID', 'reason', 'managerID', 'token'].includes(key) && value) {
            localizedReasons.push(value);
        }
    });
    group.reasons = [reason, ...localizedReasons].filter(Boolean);
    return successResponse();
};

const updateTrainingGroupReasonAnalysis = (params = new URLSearchParams()) => {
    const group = findTrainingGroup(params.get('groupID'));
    if (group) {
        group.reasonAnalysis = params.get('reasonAnalysis') || '';
    }
    return successResponse();
};

const assignTrainingAttendeeToGroup = (params = new URLSearchParams()) => {
    ensureTrainingGroupState();
    const scheduleID = String(params.get('scheduleID') || '');
    const groupID = String(params.get('groupID') || '');
    if (meetGroups.findSchedule(scheduleID)) return trainingMeetResponse(() => { meetGroups.assign(scheduleID, groupID); return { success: 'true' }; });
    const attendee = resumes.find(item => String(item.scheduleID) === scheduleID);
    const group = findTrainingGroup(groupID);

    if (!attendee || !group) {
        return jsonResponse({
            success: 'false',
            error: {
                errorCode: 'TRAINING_ASSIGNMENT_FAILED',
                errorMessage: 'Training Mode mock assignment target was not found.'
            }
        }, 400);
    }

    state.ungroupedScheduleIDs = state.ungroupedScheduleIDs.filter(id => String(id) !== scheduleID);
    state.groupedAttendees.forEach(existingGroup => {
        existingGroup.attendees = (existingGroup.attendees || [])
            .filter(existingAttendee => String(existingAttendee.scheduleID) !== scheduleID);
    });
    group.attendees.push(cloneTrainingAttendeeForGroup(attendee, groupID));

    return successResponse();
};

const buildTrainingAutoGroupedAttendees = (params = new URLSearchParams()) => {
    ensureTrainingGroupState();
    const timeSlot = params.get('timeSlot') || meetTimes[0].meetTime;
    const shuffledResumes = shuffled(resumes);
    const groupCount = Math.max(1, Math.ceil(shuffledResumes.length / TRAINING_AUTO_GROUP_SIZE));
    const chunks = Array.from({ length: groupCount }, () => []);

    shuffledResumes.forEach((attendee, index) => {
        chunks[index % groupCount].push(attendee);
    });

    state.groupedAttendees = chunks.map((attendees, index) => {
        const meetGroupID = String(600 + index + 1);
        const location = restaurants[index % restaurants.length] || {};
        return {
            meetGroupID,
            bookedTime: timeSlot,
            locationID: location.locationID || '',
            locationName: location.name || 'Training Location',
            reservationName: `Training Auto ${index + 1}`,
            remarks: 'Training Mode mock auto group. Safe to practice.',
            reasons: [
                'Training Mode mock: 隨機分組結果',
                'Training Mode mock: AI 後續流程已模擬通過'
            ],
            reasonAnalysis: JSON.stringify({
                pickedModelNumber: 3,
                pickedModelName: '共同興趣桌',
                confidence: 0.86,
                reason: [
                    'Training Mode mock: 依一組 6 人上限隨機平均分配。',
                    'Training Mode mock: AI 後續檢查已模擬通過。'
                ],
                modelDescription: {
                    zh: 'Training Mode mock：這是自動分組後產生的練習桌，每組以 6 人為上限並平均分配，適合熟悉分組、描述與風險評估流程。',
                    en: 'Training Mode mock: This practice table was generated with a six-person cap and balanced distribution for reviewing descriptions and risk checks.'
                },
                cautions: []
            }),
            locked: '0',
            modelID: 'training-model-balanced',
            attendees: attendees.map(attendee => cloneTrainingAttendeeForGroup(attendee, meetGroupID))
        };
    });
    state.ungroupedScheduleIDs = [];

    return state.groupedAttendees;
};

const getTrainingUngroupedAttendees = () => {
    ensureTrainingGroupState();
    const scheduleIDSet = new Set(state.ungroupedScheduleIDs.map(String));
    return resumes
        .filter(attendee => scheduleIDSet.has(String(attendee.scheduleID)))
        .map(attendee => cloneTrainingAttendeeForGroup(attendee, ''));
};

const getTrainingGroupedAttendees = () => {
    ensureTrainingGroupState();
    return state.groupedAttendees;
};

const trainingRefund = params => meetGroups.findSchedule(params.get('scheduleID'))
    ? trainingMeetResponse(() => { meetGroups.refund(params.get('scheduleID')); return { success: 'true' }; })
    : successResponse();

const endpointHandlers = {
    managerLogin: () => jsonResponse({
        error: { errorCode: '', errorMessage: '' },
        token: 'training-token',
        managerID: 'training-manager',
        name: 'Training Admin',
        authorization: '1'
    }),
    updateManagerPassword: () => successResponse(),
    createManager: (params) => createTrainingManager(params),
    allCountries: () => jsonResponse(managementData.map(country => ({
        countryID: country.countryID, name: country.name, code: country.code || '',
        currency: country.currency || '', symbol: country.symbol || '', available: country.available ?? '1', languages: country.languages || []
    }))),
    updateCountry: (params) => {
        const country = managementData.find(row => row.countryID === params.get('countryID'));
        if (!country) return jsonResponse({ success: 'false' });
        for (const key of ['currency', 'symbol', 'available']) country[key] = params.get(key);
        return successResponse();
    },
    addCountryLanguage: (params) => {
        const country = managementData.find(row => row.countryID === params.get('countryID'));
        const code = params.get('code');
        if (!country || !code || country.languages?.some(row => row.code === code)) return jsonResponse({ success: 'false' });
        country.languages ||= [];
        country.languages.push({ languageID: String(country.languages.length + 1), language: code, code });
        return successResponse();
    },
    allCities: () => jsonResponse(clone(managementData)),
    managers: () => jsonResponse(getTrainingManagers()),
    createCity: () => successResponse({ cityID: 'training-city' }),
    updateCity: () => successResponse(),
    cityManagers: (params) => jsonResponse(clone(
        state.managers.filter(manager => String(manager.cityID) === String(params.get('cityID') || ''))
    )),
    assignManagerToCity: (params) => assignTrainingManagerToCity(params),
    revokeManager: (params) => revokeTrainingManager(params),
    resetManagerPassword: (params) => resetTrainingManagerPassword(params),
    manageableCities: () => jsonResponse(clone(managementData)),
    userResumes: () => jsonResponse(clone(resumes)),
    unratedResumes: () => jsonResponse(clone(resumes.filter(item => Number(item.rating || 0) < 4))),
    resumeEmails: () => jsonResponse(resumes.map(item => ({
        resumeID: item.resumeID,
        UID: item.UID,
        name: item.name,
        email: item.email
    }))),
    totalResumes: () => textResponse(resumes.length),
    cityTags: () => jsonResponse(clone(cityTags)),
    cityLanguages: () => jsonResponse(['zh-Hant', 'en-Latn', 'ja-Latn']),
    cityOfficialLanguages: () => jsonResponse(['zh', 'en']),
    cityNationalities: () => jsonResponse([
        { nationalityID: '158', name: 'Taiwan' },
        { nationalityID: '81', name: 'Japan' },
        { nationalityID: '840', name: 'United States' }
    ]),
    addCityTag: () => successResponse(),
    updateCityTag: () => successResponse(),
    removeCityTag: () => successResponse(),
    addResumeTag: () => successResponse(),
    removeResumeTag: () => successResponse(),
    updateResumeActualAge: () => successResponse(),
    updateResumeRemarks: () => successResponse(),
    resumeRatings: () => jsonResponse([
        { fromResumeID: '9002', name: 'Bella Practice', rating: '4', comment: 'Mock rating feedback.' },
        { fromResumeID: '9003', name: 'Chris Demo', rating: '5', comment: 'Positive training feedback.' }
    ]),
    updateResumeRiskAnalysis: () => successResponse(),
    rateResume: () => successResponse(),
    setVerificationFailed: () => successResponse(),
    verifyResumePhoto: () => successResponse(),

    ungroupedAttendees: () => jsonResponse(clone(getTrainingUngroupedAttendees())),
    groupedAttendees: () => jsonResponse(clone(getTrainingGroupedAttendees())),
    assignableLocations: () => jsonResponse(clone(restaurants)),
    usedPromoCodes: () => jsonResponse([
        { code: 'TRAINING50', uses: 2 },
        { code: 'THEMEDEMO', uses: 1 }
    ]),
    algoGroupAttendees: async (params) => {
        await wait(TRAINING_GROUPING_DELAY_MS);
        buildTrainingAutoGroupedAttendees(params);
        return successResponse({
            groupedCount: state.groupedAttendees?.length || 0,
            ungroupedCount: 0
        });
    },
    groupingMeetTimes: (params) => jsonResponse(clone(filterTrainingCityMeetTimes(params)
        .filter(row => !params.get('date') || row.meetTime.slice(0, 10) === params.get('date')))),
    meetUngroupedAttendees: params => trainingMeetResponse(() => meetGroups.ungrouped(params.get('meetTimeID'))),
    meetGroupedAttendees: params => trainingMeetResponse(() => meetGroups.grouped(params.get('meetTimeID'))),
    createMeetGroup: params => trainingMeetResponse(() => meetGroups.create(params.get('meetTimeID'))),
    algoGroupMeetAttendees: async params => {
        await wait(TRAINING_GROUPING_DELAY_MS);
        return trainingMeetResponse(() => meetGroups.autoGroup(params.get('meetTimeID')));
    },
    cityMovableMeetTimes: (params) => jsonResponse(clone(getTrainingCityMovableMeetTimes(params))),
    updateGroupLocation: (params) => updateTrainingGroupInfo(params),
    updateGroupReason: (params) => updateTrainingGroupReason(params),
    updateGroupReasonAnalysis: (params) => updateTrainingGroupReasonAnalysis(params),
    updateGroupReservation: (params) => updateTrainingGroupInfo(params),
    updateGroupRemarks: (params) => updateTrainingGroupInfo(params),
    assignToGroup: (params) => assignTrainingAttendeeToGroup(params),
    createGroup: (params) => jsonResponse(createTrainingGroup(params)),
    groupingModels: () => jsonResponse([
        { modelID: 'training-model-balanced', name: 'Balanced Training Model', description: 'Mock model for practice.' },
        { modelID: 'training-model-risk-aware', name: 'Risk-aware Training Model', description: 'Mock model for practice.' }
    ]),
    updateGroupInfo: (params) => updateTrainingGroupInfo(params),
    refundResumeSchedule: params => trainingRefund(params),
    cancelResumeSchedule: params => trainingRefund(params),
    moveScheduleCity: () => successResponse(),
    moveSchedule: params => meetGroups.findSchedule(params.get('scheduleID'))
        ? trainingMeetResponse(() => { meetGroups.move(params.get('scheduleID'), params.get('meetTimeID')); return { success: 'true' }; })
        : successResponse(),

    cityLocations: () => jsonResponse(clone(restaurants.map(row => ({ ...row, bookedTimes: [...new Set([...(row.bookedTimes || []), ...(state.restaurantBookings.get(row.locationID) || [])])] })))),
    updateLocationInfo: () => successResponse(),
    addLocation: () => successResponse({ locationID: String(400 + restaurants.length) }),
    cityMeetTimes: (params) => jsonResponse(clone(filterTrainingCityMeetTimes(params))),
    cityMeetTimesNew: (params) => jsonResponse(clone(filterTrainingCityMeetTimes(params))),
    addCityMeetTime: (params) => addTrainingCityMeetTime(params),
    updateCityMeetTime: (params) => updateTrainingCityMeetTime(params),
    removeCityMeetTime: (params) => removeTrainingCityMeetTime(params),
    uploadCityImage: () => jsonResponse({ success: 'false', message: 'Training mode does not upload images.' }),
    cityMeetTimeRules: (params) => jsonResponse(filterTrainingCityMeetTimeRules(params)),
    addCityMeetTimeRule: (params) => addTrainingCityMeetTimeRule(params),
    updateCityMeetTimeRule: (params) => updateTrainingCityMeetTimeRule(params),
    cityMeetTypes: (params) => jsonResponse(filterTrainingCityMeetTypes(params)),
    availableMeetTypes: (params) => jsonResponse(filterTrainingAvailableMeetTypes(params)),
    createMeetType: (params) => createTrainingMeetType(params),
    updateMeetType: (params) => updateTrainingMeetType(params),
    addMeetTypeLocale: (params) => addTrainingMeetTypeLocale(params),
    updateMeetTypeLocale: (params) => updateTrainingMeetTypeLocale(params),
    markLocationBooked: params => {
        const locationID = params.get('locationID');
        const times = state.restaurantBookings.get(locationID) || new Set();
        times.add(params.get('timeSlot'));
        state.restaurantBookings.set(locationID, times);
        return successResponse();
    },
    removeLocationReservation: () => successResponse(),

    feedbacks: (params) => jsonResponse(clone(filterFeedbackGroups(params))),
    feedbackStats: (params) => jsonResponse(clone(buildFeedbackStats(params))),
    feedbackLocations: () => jsonResponse(restaurants.map(item => ({
        locationID: item.locationID,
        name: item.name
    }))),

    countryPromoCodes: (params) => jsonResponse(clone(filterPromoCodes(params))),
    cityPromoCodes: (params) => jsonResponse(clone(filterPromoCodes(params))),
    addCityPromoCode: () => successResponse({ promoCodeID: String(state.nextPromoCodeID++) }),
    addCountryPromoCode: () => successResponse({ promoCodeID: String(state.nextPromoCodeID++) }),
    updatePromoCode: () => successResponse(),
    promoCodeLocales: () => jsonResponse([
        { lang: 'zh', title: '訓練優惠碼', details: '本內容只用於 Training Mode。' },
        { lang: 'en', title: 'Training Promo Code', details: 'Training Mode only.' }
    ]),
    updatePromoCodeLocale: () => successResponse(),

    scheduledNotifications: () => jsonResponse(clone(notifications)),
    scheduleNotification: () => successResponse({ notificationID: String(state.nextNotificationID++) }),
    updateScheduledNotification: () => successResponse(),
    addNotificationDetails: () => successResponse({ detailID: 'training-detail' }),
    updateNotificationPromoCode: () => successResponse(),
    updateNotificationDetails: () => successResponse(),
    removeNotificationDetails: () => successResponse(),

    signUpStats: () => jsonResponse(clone(signUpStatsRows)),
    cityPayments: () => jsonResponse(clone(paymentRows)),
    cityRevenue: () => jsonResponse({
        currency: 'TWD',
        captured: 2,
        uncaptured: 1,
        income: 270000,
        usd: 8500,
        fee: 8100,
        tax: 13500,
        profit: 248400
    }),
    cityCanceledFees: () => jsonResponse([
        { name: 'Training Cancel Case', amount: 50000, currency: 'TWD', canceledTime: '2026-06-22 12:00:00' }
    ]),
    cityAttendance: () => jsonResponse({ attended: 14, absent: 2, canceled: 1 }),
    seasonPassPayments: () => jsonResponse(clone(paymentRows)),
    seasonPassRevenue: () => jsonResponse({
        currency: 'TWD',
        income: 270000,
        uncaptured: 120000,
        usd: 8500,
        fee: 8100,
        tax: 13500,
        profit: 248400
    }),

    edmTypes: () => jsonResponse(clone(edmTypes)),
    edms: () => jsonResponse(clone(edms)),
    addEDMVersion: () => successResponse({ edmID: String(state.nextEdmID++) }),
    cityEDMs: () => jsonResponse(clone(edms)),
    sampleEDMContents: () => jsonResponse([
        { key: 'title', value: 'Training Mode Sample Title' },
        { key: 'body', value: 'This mock content is safe to edit.' }
    ]),
    sampleEDM: () => jsonResponse({ subject: 'Training EDM Sample', contents: [] }),
    edmDetails: () => jsonResponse(clone(edms[0])),
    edmContent: () => jsonResponse([
        { key: 'heroTitle', value: 'Training Mode EDM' },
        { key: 'body', value: 'Practice editing content without sending real email.' }
    ]),
    releaseEDMVersion: () => successResponse(),
    addEDM: () => successResponse({ edmID: String(state.nextEdmID++) }),
    updateEDM: () => successResponse(),
    sendTestEDM: () => successResponse(),
    updateEDMContent: () => successResponse(),

    askGemini: async (params) => {
        await delayTrainingAiResponse();
        return jsonResponse(buildTrainingAiResponse(params.get('prompt')));
    }
};

export const handleTrainingApiRequest = async (input, init = {}) => {
    const endpoint = getEndpointName(input);
    const params = parseBodyParams(init);
    const handler = endpointHandlers[endpoint];

    if (!handler) {
        return null;
    }

    await new Promise(resolve => setTimeout(resolve, 80));
    console.info('[Training Mode] Mock API response:', endpoint);
    return handler(params);
};
